import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-heading font-bold text-background-50 mb-4">禁漫天堂</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              国内领先的漫画阅读平台，致力于为广大漫画爱好者提供安全、便捷、优质的阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors">首页</Link></li>
              <li><Link to="/category" className="text-sm text-background-400 hover:text-primary-400 transition-colors">漫画分类</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">帮助中心</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors">使用教程</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors">常见问题</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors">联系我们</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors">用户协议</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关注我们</h4>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-background-50 text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-background-50 text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200" aria-label="QQ">
                <i className="ri-qq-line text-background-50 text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200" aria-label="B站">
                <i className="ri-bilibili-line text-background-50 text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 禁漫天堂. All rights reserved.
          </p>
          <div className="flex gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors">服务条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors" rel="nofollow">站点地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}